import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { message, Popover, Modal } from 'antd';
import Scrollbar from 'react-scrollbars-custom';
import Util from '../../../script/util';
import { DDEmpty } from '../../globalPageStatus';
import HTTP from '../../../script/service';
import PropDetailsModal from './PropDetailsModal';
import AchieveItem from '../dsUserAchieve/AchieveItem';
import CustomCarousel from './CustomCarousel';
import { debounce } from 'lodash-es';
import './PropAtlas.scss';
import WEBROOM from '../../../store/WebRoom';

const SORT_ORDER = ['asc', 'desc']; // 排序字典

const calcLevelIcons = (level) => {
  const result = [];
  const chars = [1, 2, 3, 4, 5];
  if (level < 5) {
    while (result.length < level) {
      result.push(1);
    }
  } else {
    const i = Math.floor(level / 4);
    const n = level % 4;
    let index = 0;
    while (index < 4) {
      if (n === 0) {
        result.push(chars[i - 1]);
      } else {
        if (index < n) {
          result.push(chars[i]);
        } else {
          result.push(chars[i - 1]);
        }
      }
      index++;
    }
  }
  return result;
};

const getBarWidth = (list) => {
  return (
    (list.filter((e) => e.rewardStatus > -1).length / list.length) * 100 + '%'
  );
};

const DEFAULT_LIMIT = 20;
class PropAtlas extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sort: {
        field: 'price',
        order: 'asc', // null 无 asc 升序 desc 降序
      },
      sortList: [
        // { name: "价值", type: "price" },
        { name: '时间', type: 'time' },
        // { name: "数量", type: "num" },
      ],
      levelPopoverVisible: false, // 等级选择弹窗
      selectLevel: null, // 当前选中的等级
      list: [], // 道具列表
      statistics: {}, // 统计数据
      pagination: {
        page: 1, // 当前页码
        limit: DEFAULT_LIMIT, // 每页条数
        is_more: true, // 是否有更多
      },
      tab: 0,
      awardIndex: 0,
      carouselIndex: 0,
      carList: [], //座驾列表
      carDetail: [], //座驾详情
      carAward: [], // 奖励列表
    };
  }

  componentDidMount() {
    this.getPropList();
  }
  // 获取座驾列表
  getCarList = (payload = { page: 1, limit: DEFAULT_LIMIT }) => {
    const { ds } = this.props;
    const { pagination } = this.state;

    if (payload.page === 1) {
      pagination.is_more = true;
    }

    if (!pagination.is_more) return; // 没有更多数据了
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });

    const params = {
      targetUid: ds.uid,
    };

    params.page = payload.page;
    params.size = 1000;

    HTTP._get_user_prop_car(params)
      .then((res) => {
        if (res?.code === 200) {
          this.setState({ carList: res.data?.list }, () => {
            this.getCarDetail();
          });
        } else {
          message.warning(res?.message || '获取座驾列表失败，请稍后重试');
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };
  //座驾详情
  getCarDetail = () => {
    const { ds } = this.props;
    const { carList, carouselIndex } = this.state;
    const params = {
      carConfigId: carList[carouselIndex]?.carConfigId,
      targetUid: ds.uid,
    };
    HTTP._get_user_prop_car_detail(params)
      .then((res) => {
        if (res?.code === 200) {
          this.setState({
            carDetail: res.data?.levelList || [],
            carAward: res.data?.rewardList || [],
          });
        } else {
          message.warning(res?.message || '获取座驾列表失败，请稍后重试');
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };
  // 获取道具列表
  getPropList = (payload = { page: 1, limit: DEFAULT_LIMIT }) => {
    const { ds } = this.props;
    const { sort, selectLevel, tab, list, pagination } = this.state;

    if (tab == 0) {
      this.getCarList();
      return;
    }
    if (payload.page === 1) {
      pagination.is_more = true;
    }

    if (!pagination.is_more) return; // 没有更多数据了
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });

    const params = {
      targetUid: ds.uid,
      rarityLevels: null,
      toolType: tab,
      sort: sort.order,
    };

    if (selectLevel) {
      params.rarityLevels = selectLevel.level;
    }
    params.page = payload.page;
    params.size = payload.limit;

    HTTP._get_user_prop_tool(params)
      .then((res) => {
        if (res?.code === 200) {
          let array = [];
          pagination.page = payload.page;
          pagination.limit = payload.limit;

          if (res.data?.list) {
            if (payload.page === 1) {
              this.propAtlasScroll && this.propAtlasScroll.scrollToTop();
              array = res.data.list;
            } else {
              array = [...list, ...res.data.list];
            }
            if (res.data.list.length < DEFAULT_LIMIT) {
              pagination.is_more = false;
            }
          }
          this.setState({ list: array, pagination });
          if (pagination.page == 1) {
            this.setState({ statistics: res.data.statistics });
          }
        } else {
          message.warning(res?.message || '获取道具列表失败，请稍后重试');
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  // 获取奖励详情
  getAwardDetail = (level) => {
    const { carList, carouselIndex } = this.state;
    let params = {
      carConfigId: carList[carouselIndex]?.carConfigId,
      level,
    };
    HTTP._get_user_prop_car_award(params)
      .then((res) => {
        if (res?.code === 200) {
          const content = (
            <div className="prop-award-list">
              {res.data.map((item, i) => (
                <div className="prop-award-item" key={i}>
                  <div className="prop-award-cover">
                    <img
                      src={Util.transImgUrl(item.showPic, '150x150')}
                      alt=""
                    />
                  </div>
                  <div className="prop-award-name">
                    <span>{item.name}</span>
                  </div>
                </div>
              ))}
            </div>
          );
          Modal.success({
            title: '奖励详情',
            icon: null,
            className: 'daidai-confirm-style prop-atlas-modal',
            centered: true,
            content,
            okText: '开心收下',
            onOk: () => {
              this.getAward(level);
            },
            zIndex: 1010,
          });
        } else {
          message.warning(res?.message);
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  //获取奖励
  getAward = (level) => {
    const { carList, carouselIndex } = this.state;
    let params = {
      carConfigId: carList[carouselIndex]?.carConfigId,
      level,
    };
    HTTP._get_user_prop_car_reward(params)
      .then((res) => {
        if (res?.code === 200) {
          message.success('领取成功');
          this.getPropList();
        } else {
          message.warning(res?.message || '领取失败');
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  // 修改排序
  onChangeSort = (item) => {
    const { sort } = this.state;
    let nextIndex = 0;
    if (item.type === sort.field) {
      const index = SORT_ORDER.indexOf(sort.order);
      nextIndex = index + 1;
      if (nextIndex > SORT_ORDER.length - 1) {
        nextIndex = 0;
      }
    }
    this.setState(
      { sort: { field: item.type, order: SORT_ORDER[nextIndex] } },
      () => {
        this.getPropList();
      }
    );
  };

  // 修改等级选择弹窗
  onChangePopoverVisible = () => {
    const { levelPopoverVisible } = this.state;
    this.setState({ levelPopoverVisible: !levelPopoverVisible });
  };

  onChangeLevel = (item) => {
    this.setState({ selectLevel: item }, () => {
      this.onChangePopoverVisible();
      this.getPropList();
    });
  };

  /// 滚动翻页
  handleScroll = debounce((e) => {
    if (this.state.tab == 0) return;
    if (e.scrollHeight - (e.scrollTop + e.clientHeight) < 10) {
      const { pagination } = this.state;
      this.getPropList({ page: pagination.page + 1, limit: pagination.limit });
    }
  }, 300);

  // 渲染等级选择弹窗
  renderPopoverContent = () => {
    // const { levelTags } = this.props;
    const { selectLevel } = this.state;
    let levelTags = [
      {
        level: 0,
        title: '初级',
      },
      {
        level: 1,
        title: '高级',
      },
      {
        level: 2,
        title: '稀有',
      },
      {
        level: 3,
        title: '史诗',
      },
    ];
    return (
      <>
        <span
          className={Util.classNames('sort-item-text', {
            active: selectLevel == null,
          })}
          onClick={() => this.onChangeLevel(null)}
        >
          全部
        </span>
        {levelTags.map((item) => (
          <span
            key={item.level}
            className={Util.classNames('sort-item-text', {
              active: item.level === selectLevel?.level,
            })}
            onClick={() => this.onChangeLevel(item)}
          >
            {item.title}
          </span>
        ))}
      </>
    );
  };

  handleTabChange = (tab) => {
    this.setState(
      {
        tab,
        list: [],
        carList: [],
        selectLevel: null,
        sort: { field: null, order: null },
      },
      () => {
        this.getPropList();
      }
    );
    this.propAtlasScroll && this.propAtlasScroll.scrollToTop();
  };
  //奖励翻页
  handleDirection = (bool) => {
    if (bool) {
      this.setState({ awardIndex: 1 });
    } else {
      this.setState({ awardIndex: 0 });
    }
  };

  //切换回调
  carouselChange = (index) => {
    this.setState({ carouselIndex: index }, () => {
      setTimeout(() => {
        this.getCarDetail();
      }, 300);
    });
  };
  // 选择座驾
  onSelectCurrentGift = (data) => {
    this.atlasDetailsElement.showModal(data);
  };

  render() {
    const {
      base: { atlasLoading },
      ds,
    } = this.props;
    const {
      list,
      sort,
      sortList,
      statistics,
      levelPopoverVisible,
      selectLevel,
      tab,
      awardIndex,
      carouselIndex,
      carList,
      carDetail,
      carAward,
    } = this.state;
    return (
      <div className="prop-atlas-wrap noSelect">
        <div className="prop-tab">
          <div
            className={`prop-tab-item ${tab == 0 && 'active'}`}
            onClick={() => this.handleTabChange(0)}
          >
            <span>座驾</span>
            <Popover
              trigger="click"
              topRight="bottomRight"
              rootClassName="park-car-popover"
              content={
                <div style={{ width: '375px', height: '300px' }}>
                  <Scrollbar className="my-scroll-bar">
                    <div className="tit">房间座驾展示</div>
                    <p>1.展示房间用户当前停放的座驾，隐身用户座驾不展示哦； </p>
                    <p>
                      2.展示顺序：座驾等级越高，展示越靠前，同等级按照停放时间的先后排列。
                    </p>
                    <div className="tit">房间座驾加成</div>
                    <p>
                      1.不同的座驾，不同等级的座驾均会影响座驾加成，等级越高加成越多，实际加成以页面显示为准；
                    </p>
                    <p>
                      2.用户在房间停放座驾后，达到一定的停放时长，即可给房间加成热度，热度加成时间每日有上限，座驾有效期低于1天会影响加成哦；
                    </p>
                    <p style={{ color: '#FFD253' }}>
                      3.座驾仅可停放在一个房间进行热度加成。
                    </p>
                  </Scrollbar>
                </div>
              }
            >
              <i className={`icon icon-mark ${tab == 0 && 'active'}`}></i>
            </Popover>
          </div>
          <div
            className={`prop-tab-item ${tab == 1 && 'active'}`}
            onClick={() => this.handleTabChange(1)}
          >
            <span>麦位框</span>
          </div>
          <div
            className={`prop-tab-item ${tab == 4 && 'active'}`}
            onClick={() => this.handleTabChange(4)}
          >
            <span>进场秀</span>
          </div>
          <div
            className={`prop-tab-item ${tab == 5 && 'active'}`}
            onClick={() => this.handleTabChange(5)}
          >
            <span>语聊气泡</span>
          </div>
          <div
            className={`prop-tab-item ${tab == 14 && 'active'}`}
            onClick={() => this.handleTabChange(14)}
          >
            <span>麦位声波</span>
          </div>
          <div
            className={`prop-tab-item ${tab == 15 && 'active'}`}
            onClick={() => this.handleTabChange(15)}
          >
            <span>昵称尾灯</span>
          </div>
        </div>
        {tab != 0 ? (
          <div className="prop-atlas-header">
            <div className="sub-title">
              <span className="title">
                {tab == 1 && '麦位框'}
                {tab == 4 && '进场秀'}
                {tab == 5 && '语聊气泡'}
                {tab == 14 && '麦位声波'}
                {tab == 15 && '昵称尾灯'}
                图鉴 {statistics.collectCount || 0}
              </span>
              /{statistics.totalPropCount || 0}
            </div>

            <ul className="sort-type noSelect">
              {sortList.map((item) => (
                <li
                  key={item.type}
                  className="sort-item"
                  onClick={() => this.onChangeSort(item)}
                >
                  <span>{item.name}</span>
                  <span className="icon">
                    <label
                      className={Util.classNames('up', {
                        active:
                          sort.field === item.type && sort.order === 'asc',
                      })}
                    />
                    <label
                      className={Util.classNames('down', {
                        active:
                          sort.field === item.type && sort.order === 'desc',
                      })}
                    />
                  </span>
                </li>
              ))}
            </ul>
            <Popover
              rootClassName="daidai-popover-default prop-level-popover"
              trigger="click"
              placement="bottom"
              open={levelPopoverVisible}
              content={this.renderPopoverContent()}
            >
              <div
                className="sort-item level"
                onClick={this.onChangePopoverVisible}
              >
                <span className="sort-select-text">
                  {selectLevel?.title || '全部'}
                </span>
                <span className="icon">
                  <label
                    className={Util.classNames(
                      'active',
                      levelPopoverVisible ? 'down' : 'up'
                    )}
                  />
                </span>
              </div>
            </Popover>
          </div>
        ) : null}
        <div className="prop-atlas-content">
          <Scrollbar
            ref={(el) => (this.propAtlasScroll = el)}
            onScroll={this.handleScroll}
          >
            {tab == 0 ? (
              <CustomCarousel
                index={carouselIndex}
                list={carList}
                showTime={ds?.uid == WEBROOM?.uid}
                afterChange={this.carouselChange}
              />
            ) : null}
            {tab == 0 && carAward.length > 0 ? (
              <div className="prop-award">
                {carAward.length > 7 ? (
                  <div className="prop-direction">
                    <i
                      className={`icon icon-left ${awardIndex <= 0 ? 'disabled' : ''}`}
                      onClick={() => this.handleDirection(false)}
                    />
                    {carAward.length < 7 ? (
                      <i className={`icon icon-right disabled`} />
                    ) : (
                      <i
                        className={`icon icon-right`}
                        onClick={() => this.handleDirection(true)}
                      />
                    )}
                  </div>
                ) : null}
                <div className="prop-award-box">
                  <div
                    className={`carousel-box ${awardIndex == 1 ? 'p2' : 'p1'}`}
                  >
                    <div
                      className="prop-award-progress"
                      style={{ '--bar-width': getBarWidth(carAward) }}
                    >
                      <div className="prop-award-bar"></div>
                    </div>
                    <div className="carousel-item">
                      {carAward?.map((item, index) => (
                        <div
                          className={`prop-award-item a${item.rewardStatus}`}
                          key={index}
                        >
                          <div className="prop-award-cover"></div>
                          <div className="prop-award-lv">
                            {item.rewardStatus == 0 ? (
                              <div
                                className="btn btn-get"
                                onClick={() => this.getAwardDetail(item.level)}
                              ></div>
                            ) : (
                              <span>Lv.{item.level || 1}</span>
                            )}
                          </div>
                          <div
                            className={`prop-award-dot ${item.rewardStatus > -1 ? 'active' : ''}`}
                          ></div>
                          <div className="prop-award-name">
                            {item.rewardName}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {tab == 0 ? (
              <>
                {carDetail ? (
                  <div className="prop-atlas-box">
                    {carDetail.map((item, index) => (
                      <AchieveItem
                        key={index}
                        className="prop-atlas-item is-car"
                        status={item.lightUpStatus}
                        cover={item.titlePic}
                        name={carList[carouselIndex]?.name}
                        onClick={() => this.onSelectCurrentGift(item)}
                      >
                        <div className="car-level">
                          {item?.level &&
                            calcLevelIcons(item.level).map((n, i) => (
                              <span
                                key={i}
                                className={`icon icon-level lv-${n}`}
                              />
                            ))}
                        </div>
                      </AchieveItem>
                    ))}
                  </div>
                ) : (
                  !atlasLoading && (
                    <DDEmpty
                      description="暂无座驾"
                      className="prop-atlas-empty"
                    />
                  )
                )}
              </>
            ) : (
              <>
                {list?.length ? (
                  <div className="prop-atlas-box">
                    {list.map((item, index) => (
                      <AchieveItem
                        key={index}
                        className="prop-atlas-item"
                        status={item.lightUpStatus}
                        cover={item.titlePic}
                        name={item.name}
                      >
                        {item?.backgroundPic && (
                          <div
                            className="item-bg"
                            style={{
                              backgroundImage: `url(${Util.transImgUrl(item.backgroundPic, '100x100')})`,
                            }}
                          />
                        )}
                      </AchieveItem>
                    ))}
                  </div>
                ) : (
                  !atlasLoading && (
                    <DDEmpty
                      description="暂无道具"
                      className="prop-atlas-empty"
                    />
                  )
                )}
              </>
            )}
          </Scrollbar>
        </div>
        <PropDetailsModal
          cRef={(el) => (this.atlasDetailsElement = el)}
          ds={ds}
          carList={carList}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(PropAtlas);
